import { type WithChildren } from "@common/declarations";
import { type I18n, merge } from "@common/lib/i18n";
import React from "react";

export type I18nContextProps = {
  i18n: I18n;
};

export const I18nContext = React.createContext<I18nContextProps>({
  i18n: {}
});

type Props = WithChildren & {
  i18n?: I18n;
};
export const I18nContextProvider = (props: Props) => {
  const i18n = React.useMemo(() => merge(props.i18n), [props.i18n]);

  const value = React.useMemo((): I18nContextProps => {
    return {
      i18n
    };
  }, [i18n]);

  return <I18nContext.Provider value={value}>{props.children}</I18nContext.Provider>;
};
